import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_76: FaireProductEntity = {
  token: "legacy_prod_abbott-76",
  type: "product",
  name: "Large Orchids & Peonies Napkins, 20 Pack",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3edd70c5808ab5e337f8788021545ea851b27be671dad62856acee91aa067344.jpeg",
  priceDollars: 12,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_party-supplies"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
